import React from "react"
import TopTitle from "@components/TopTitle"
import Wrapper from "@components/Wrapper"
import styles from "./SectionOne.module.scss"
import ArticleGraphic from "./SectionOne.png";


export default class SectionOne extends React.Component {

    render() {
        return (
            <section className="container-fluid bg-xl-light-gray">
                <div className="row ml-0 mr-0">
                    <Wrapper className={"w-100 text-left"} gap="outer">
                        <div className="row bg-white justify-content-center pt-10">
                            <div className={"col-auto col-lg-10 m-lg-2 " + styles.contactParent}>
                                <h3
                                className={
                                    styles.title +
                                    " proxima-nova--extra-bold text-secondary fs-30pt fs-lg-42pt pb-10"
                                }
                                >
                                    Single Sign-On, The Heavy Lifter of Cyber Security
                                </h3>
                                <div className={styles.contactRow + " row bg-white"}>
                                    <div className={ styles.topTextBody + " col-12"}>
                                        <img alt="EngineID App Launch" className={styles.tabletImage} src={ArticleGraphic} />
                                        <p>
                                            We live in a world where there is an endless supply of software applications to solve our every problem. But these apps run in their own silos, disconnected from 
                                            each other. You need a separate account for <i>everything</i>. This leads to <b>login fatigue</b>. People get tired of having to remember different passwords and get sick of 
                                            having to manually log in over and over.
                                        </p>
                                        <p>
                                            Login fatigue also leads to significant security risks as well. How do you know if staff members aren’t using the same password for everything? If their password becomes 
                                            compromised on any of the many apps they use, every app is now considered compromised.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Wrapper>
                </div>
            </section>
        );
    }
}